module.exports = __webpack_public_path__ + "media/images/help/submission-management-select-labels-99c7cd7246c8b3ab197d244d190b61f0.png";